import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';
import exact from 'prop-types-exact';
import {
  Table,
  Button,
} from 'react-bootstrap';

import { toDollarFormat, openInNewTab } from '../../../utils';
import { getBonusMonth, getUserBonusMonthId } from '../selectors';
import { getBonusesLink } from '../links';
import { queryGetUserMonthBonusGQL } from '../graphql/userMonthBonusApi';
import NewTabLink from '../../../components/NewTabLink';
import { getTicketLink } from '../../ticketViewer/links';

/* TODO: move the ticket state styling outside timesheetDetails */
import '../../timesheetApprovals/components/TimesheetDetails.css';

const UNAVAILABLE = 'unavailable';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  allUserTicketBonuses: PropTypes.array.isRequired,
  bonusMonth: PropTypes.string.isRequired,

  userBonusMonthId: PropTypes.number.isRequired,
});
/* eslint-enabled react/no-unused-prop-types */

const renderDollarRate = (bonusRate) => {
  if (!bonusRate) {
    return bonusRate;
  }

  return toDollarFormat(bonusRate);
};

const handleEditBonusTicket = (bonusMonth, ticketId) => {
  const url = getBonusesLink(ticketId, bonusMonth, 'true');
  openInNewTab(url);
};

const renderTicketNumber = (ticket) => {
  const { ticketNumber: { number: tNumber }, state: ticketState } = ticket;
  const isClickable = (ticket && ticketState !== UNAVAILABLE);

  if (isClickable) {
    let ticketId = '';
    let jobId = '';
    if (ticket) {
      ticketId = ticket.id;
      jobId = ticket.job.id;
    }
    const url = getTicketLink(ticketId, jobId);
    return (
      <NewTabLink to={url}>
        {tNumber}
      </NewTabLink>
    );
  }

  return (tNumber);
};

const UserBonusTicketTable = (props) => {
  const { allUserTicketBonuses, bonusMonth } = props;
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Ticket Number</th>
            <th>Billable Hours</th>
            <th>Billable Revenue</th>
            <th>Crew Size</th>
            <th>Paid Per Diems</th>
            <th>Rate</th>
            <th>Percent</th>
            <th>Bonus Opportunity</th>
            <th>Notes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {allUserTicketBonuses.map((item) => {
            const { paidPerDiems, userTicketBonusForm } = item;

            const {
              ticket,
              bonusRate,
              bonusPercentage,
              notes,
              bonusAmount,
            } = userTicketBonusForm;

            const {
              billingHours,
              billingRevenue,
              date: { display },
              crewSize,
              id: userTicketBonusId,
              state: ticketState,
            } = ticket;

            const formattedBonusRate = renderDollarRate(bonusRate);

            return (
              <tr key={ticket.id}>
                <td>{display}</td>
                <td
                  style={{ padding: '8px', color: '#000' }}
                  className={`summary-details-${ticketState}`}
                >
                  {renderTicketNumber(ticket)}
                </td>
                <td>{billingHours}</td>
                <td>{toDollarFormat(billingRevenue)}</td>
                <td>{crewSize}</td>
                <td>{paidPerDiems}</td>
                <td>{formattedBonusRate}</td>
                <td>{bonusPercentage}</td>
                <td>{toDollarFormat(bonusAmount)}</td>
                <td>{notes}</td>
                <td>
                  <Button
                    bsStyle="info"
                    onClick={() => { handleEditBonusTicket(bonusMonth, userTicketBonusId); }}
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr />
        </tfoot>
      </Table>
    </div>
  );
};


UserBonusTicketTable.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    bonusMonth: getBonusMonth(state),
    userBonusMonthId: getUserBonusMonthId(state),
  };
};

const withRedux = connect(mapStateToProps, {});

const withNoUserBonusMonthId = branch(
  (props) => { return props.userBonusMonthId === null; },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withNoUserBonusMonthId,
  queryGetUserMonthBonusGQL,
);

export default enhance(UserBonusTicketTable);
